import { Role } from "@nerdbord/graphql-api";
import { useContext } from "react";
import { AuthContext } from "./AuthProvider";
export var useAuth = function () {
    var authContextValues = useContext(AuthContext);
    if (!authContextValues) {
        throw Error("Auth context wrapper not found");
    }
    var user = authContextValues.user, retryAuth = authContextValues.retryAuth, isLoading = authContextValues.isLoading;
    var isRole = function (role) {
        var _a;
        return (_a = user === null || user === void 0 ? void 0 : user.roles) === null || _a === void 0 ? void 0 : _a.find(function (searchedRole) { return searchedRole === role; });
    };
    var isAdmin = isRole(Role.ADMIN);
    var isOrgOwner = isRole(Role.ORG_OWNER);
    var isMentor = isRole(Role.MENTOR);
    return { user: user, retryAuth: retryAuth, isLoading: isLoading, isAdmin: isAdmin, isMentor: isMentor, isOrgOwner: isOrgOwner };
};
